import Vue from 'vue'
import App from './App.vue'
import router from './router'
import '@/assets/js/vant'

import VueLazyload from 'vue-lazyload'
Vue.use(VueLazyload)
Vue.config.productionTip = false
//* 导入公用函数
import utils from '@/assets/js/util';
Vue.prototype.$utils = utils
import {get, post} from '@/assets/js/http'
// 挂载 Vue原型对象
Vue.prototype.$get = get
Vue.prototype.$post = post
router.beforeEach((to,from,next)=>{
  document.title = to.meta.title
  next()
})
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
